import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentQuotationTask } from '@/providers/QuotationTaskProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { QuotationTaskFileEditForm } from '@/components/features/tasks/quotation/[quotation_task_id]/QuotationTaskFileEditForm';

export const QuotationTaskFiles = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`見積書等ファイル一覧`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `プロジェクト（売上） - ${_t_!.name}`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders` },
        { label: `プロジェクト（売上）詳細`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}` },
        {
          label: `見積申請タスク詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}/quotation_tasks/${task!.id}`,
        },
      ]),
    []
  );

  const { _so_ } = useCurrentSalesOrder();
  const { quotationTask: task } = useCurrentQuotationTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <QuotationTaskFileEditForm />
    </WorkspaceLayout>
  );
};
